// extracted by mini-css-extract-plugin
module.exports = {"resultContainer":"style-module__resultContainer___289P4","filteringContainer":"style-module__filteringContainer___1JSzl","filterSection":"style-module__filterSection___1DFhI"};